import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout, { LegalSection } from '../components/LegalPageLayout';
import { useBrandName } from '../context/SettingsContext';

const MentionsLegales = () => {
  const brandName = useBrandName();

  return (
    <LegalPageLayout
      title="Mentions légales"
      subtitle="Informations légales relatives à l'édition et l'hébergement de ce site."
      path="/mentions-legales"
      lastUpdated="2026-09-07"
      metaDescription={`Mentions légales du site ${brandName} — éditeur, hébergement, propriété intellectuelle et contact.`}
    >
      <LegalSection title="Éditeur du site">
        <p>
          <strong>{brandName}</strong> — Ateliers de robotique et programmation pour enfants et adolescents.
        </p>
        <ul>
          <li>Siège social : Alpes-Maritimes, France</li>
          <li>Téléphone : <a href="tel:+33698854948">06 98 85 49 48</a></li>
          <li>Email : <a href="mailto:contact@digirobot.fr">contact@digirobot.fr</a></li>
          <li>Site web : <a href="https://www.digirobot.fr">www.digirobot.fr</a></li>
        </ul>
      </LegalSection>

      <LegalSection title="Directeur de la publication">
        <p>Le représentant légal de {brandName} agit en qualité de directeur de la publication.</p>
      </LegalSection>

      <LegalSection title="Conception et développement">
        <p>
          Le site a été conçu et développé par <strong>Jean-Vincent Guglielmetti</strong>,
          prestataire indépendant. Cette mention identifie le développeur du site ;
          elle ne lui confère pas la qualité d&apos;éditeur ni de responsable de publication.
        </p>
      </LegalSection>

      <LegalSection title="Hébergement">
        <p>
          Le site est hébergé par <strong>OVH SAS</strong>
          <br />
          2 rue Kellermann, 59100 Roubaix, France
          <br />
          <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer">
            www.ovhcloud.com
          </a>
        </p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>
          L&apos;ensemble des contenus présents sur ce site (textes, images, logos, vidéos, marques)
          est la propriété exclusive de {brandName} ou de ses partenaires, sauf mention contraire.
        </p>
        <p>
          Toute reproduction, représentation, modification ou exploitation, totale ou partielle,
          sans autorisation écrite préalable est interdite et constitue une contrefaçon
          sanctionnée par le Code de la propriété intellectuelle.
        </p>
      </LegalSection>

      <LegalSection title="Limitation de responsabilité">
        <p>
          {brandName} s&apos;efforce d&apos;assurer l&apos;exactitude des informations diffusées sur ce site.
          Toutefois, {brandName} ne saurait garantir l&apos;exactitude, la précision ou l&apos;exhaustivité
          des informations mises à disposition.
        </p>
        <p>
          L&apos;utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
        </p>
      </LegalSection>

      <LegalSection title="Données personnelles">
        <p>
          Pour toute information relative au traitement de vos données personnelles,
          consultez notre{' '}
          <Link to="/politique-confidentialite">
            politique de confidentialité
          </Link>.
        </p>
      </LegalSection>

      <LegalSection title="Contact">
        <p>
          Pour toute question relative au site ou à son contenu, vous pouvez nous contacter à{' '}
          <a href="mailto:contact@digirobot.fr">contact@digirobot.fr</a>.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default MentionsLegales;
